import React, { useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MiniCenteredFooter from "components/MiniCenteredFooter.js";
import ViewSDKClient from "components/ViewSDKClient.js";
import RuleSlider from "components/RuleSlider.js";
import background from 'images/rules_background.jpg';

import intro_rewind from 'components/pdfs/intro_rewind.pdf';
import pdf_intro from 'images/pdf_intro.png';
import medoame from 'components/pdfs/medoame.pdf';
import pdf_domeame from 'images/pdf_domeame.png';
import gui_background from 'components/pdfs/gui_background.pdf';
import pdf_guibackground from 'images/pdf_guibackground.png';
import interiorcase from 'components/pdfs/interiorcase.pdf';
import pdf_interiorcase from 'images/pdf_interiorcase.png';
import magazziniere from 'components/pdfs/magazziniere.pdf';
import pdf_magazziniere from 'images/pdf_magazziniere.png';
import reg_roleplay from 'components/pdfs/reg_roleplay.pdf';
import pdf_roleplay from 'images/pdf_roleplay.png';
import reg_territori from 'components/pdfs/reg_territori.pdf';
import pdf_territori from 'images/pdf_territori.png';
import reg_rapine from 'components/pdfs/reg_rapine.pdf';
import pdf_rapine from 'images/pdf_rapine.png';
import reg_feriti from 'components/pdfs/reg_feriti.pdf';
import pdf_feriti from 'images/pdf_feriti.png';
import reg_fazioni from 'components/pdfs/reg_fazioni.pdf';
import pdf_fazioni from 'images/pdf_fazioni.png';

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover flex justify-center items-center`}
  background-image: url(${background});
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-900 opacity-75`;
const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`;
const Content = tw.div`px-4  my-auto mx-auto`;
const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-snug -mt-24 mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-600 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;


export default () => {

  const adobeDCView = new ViewSDKClient();

  const viewFile = (pdf) => {
    adobeDCView.ready().then(() => adobeDCView.previewFile("", { embedMode: "LIGHT_BOX", showDownloadPDF: false, showPrintPDF: false }, pdf))
  }

  return (<>
    <AnimationRevealPage>
      <Container style={{ minHeight: "25rem" }}>
        <OpacityOverlay />
        <HeroContainer>
          <Content>
            <Heading>
              <SlantedBackground>Regolamenti e Guide</SlantedBackground>
            </Heading>
          </Content>
        </HeroContainer>
      </Container>
      <RuleSlider slides={[{
        imageSrc: pdf_roleplay,
        title: "Roleplay",
        description: "Il regolamento generale del roleplay, contiene nozioni fondamentali.",
        rating: "8min",
        pdfUrl: reg_roleplay
      },
      {
        imageSrc: pdf_territori,
        title: "Territori",
        description: "Il regolamento delle zone di gioco, con descrizione e utilizzo.",
        rating: "2min",
        pdfUrl: reg_territori
      },
      {
        imageSrc: pdf_rapine,
        title: "Rapine, truffe e riscatti",
        description: "Le regole da sapere prima di iniziare una scena di rapina, truffa o riscatto.",
        rating: "2min",
        pdfUrl: reg_rapine
      },
      {
        imageSrc: pdf_feriti,
        title: "Feriti",
        description: "Il regolamento Feriti contiene le istruzioni per ruolare correttamente dopo aver subito una ferita.",
        rating: "3min",
        pdfUrl: reg_feriti
      },
      {
        imageSrc: pdf_fazioni,
        title: "Fazioni (Legali e Illegali)",
        description: "Questo regolamento contiene indicazioni su come aprire una fazione e linee guida per le fazioni in generale.",
        rating: "10min",
        pdfUrl: reg_fazioni
      }]} showPDF={viewFile} sliderTitle="Regolamenti di gioco" />

      <RuleSlider slides={[{
        imageSrc: pdf_intro,
        title: "Introduzione a Rewind",
        description: "Un'introduzione generale al progetto e alle sue caratteristiche.",
        rating: "5min",
        pdfUrl: intro_rewind
      },
      {
        imageSrc: pdf_domeame,
        title: "Utilizzo /do, /me e /ame",
        description: "Impara ad usare correttamente questi tre comandi fondamentali per il roleplay.",
        rating: "4min",
        pdfUrl: medoame
      },
      {
        imageSrc: pdf_guibackground,
        title: "Come fare un background PG",
        description: "In questa guida ti saranno forniti alcuni suggerimenti per scrivere al meglio la storia del tuo personaggio.",
        rating: "3min",
        pdfUrl: gui_background
      },
      {
        imageSrc: pdf_interiorcase,
        title: "Lista interior case",
        description: "Una lista di tutti gli interior delle case presenti sul server.",
        rating: "15min",
        pdfUrl: interiorcase
      },
      {
        imageSrc: pdf_magazziniere,
        title: "Guida Missione Magazziniere",
        description: "Scopri come è strutturata la missione Magazziniere di Rewind per svolgerla al meglio.",
        rating: "2min",
        pdfUrl: magazziniere
      }]} showPDF={viewFile} sliderTitle="Tutorial e Guide" />
      <div tw="pb-32" />
      <MiniCenteredFooter />
    </AnimationRevealPage>
  </>);
};
